import { render, staticRenderFns } from "./SchoolJobImg.vue?vue&type=template&id=fc02d7b0&"
import script from "./SchoolJobImg.vue?vue&type=script&lang=js&"
export * from "./SchoolJobImg.vue?vue&type=script&lang=js&"
import style0 from "./SchoolJobImg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports